document.addEventListener('DOMContentLoaded', () => {
  const roots = document.querySelectorAll('.skio-widget-root');
  if (!roots.length) return;
  roots.forEach(initSkioWidget);
});

function skioUpdateButtonVisibility(root, isAvailable) {
  if (isAvailable) {
    root.classList.add('in-stock');
    root.classList.remove('out-of-stock');
  } else {
    root.classList.add('out-of-stock');
    root.classList.remove('in-stock');
  }
}

// ── Global selling plan settings (Theme Settings → Skio Selling Plans) ─
const SKIO_PLAN_FREQUENCIES = ['30', '60', '90'];

// Accepts a raw ID ("1234567890") or a GID ("gid://shopify/SellingPlan/1234567890")
function skioNormalizePlanId(value) {
  const matches = String(value || '').match(/\d+/g);
  return matches && matches.length ? parseInt(matches[matches.length - 1], 10) : null;
}

// Parses data-skio-plans into {single: {30: id, …}, multi: {…}}; null when unconfigured
function skioParsePlanSettings(raw) {
  if (!raw) return null;
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (e) {
    console.error('Skio widget: invalid data-skio-plans', e);
    return null;
  }
  const result = { single: {}, multi: {} };
  let hasAny = false;
  ['single', 'multi'].forEach((set) => {
    SKIO_PLAN_FREQUENCIES.forEach((freq) => {
      const id = skioNormalizePlanId(parsed && parsed[set] ? parsed[set][freq] : null);
      if (id) {
        result[set][freq] = id;
        hasAny = true;
      }
    });
  });
  return hasAny ? result : null;
}

// 1 bag → single set, 2+ bags → multi set 
function skioResolvePlanId(planSettings, bagCount, frequency, fallbackId) {
  if (!planSettings) return fallbackId || null;
  const set = bagCount >= 2 ? planSettings.multi : planSettings.single;
  return set[frequency] || set['30'] || set['60'] || set['90'] || fallbackId || null;
}

// Extract bag count from a tier label like "2 BAGS" → 2
function skioGetBagCountFromLabel(label) {
  const match = (label || '').match(/(\d+)/);
  return match ? parseInt(match[1], 10) : 1;
}

/* ── Global discount tiers (Theme Settings → Discount Tiers) ──────────────
 * Parsed from data-discount-tiers. Rows are bag thresholds: a bag count takes
 * the discount of the highest row it reaches. Sorted here rather than trusting
 * the merchant to fill the rows in order.
 */
function skioParseDiscountTiers(raw) {
  const config = { rows: [], pillFormat: '{percent}% off', supplyPillFormat: 'Save {percent}%' };
  if (!raw) return config;
  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (e) {
    console.error('Skio widget: invalid data-discount-tiers', e);
    return config;
  }
  if (Array.isArray(parsed.rows)) {
    config.rows = parsed.rows
      .map((row) => ({
        bags: parseInt(row.bags, 10),
        percent: parseFloat(row.percent) || 0,
        onetime: parseFloat(row.onetime) || 0,
      }))
      .filter((row) => !isNaN(row.bags) && row.bags > 0)
      .sort((a, b) => a.bags - b.bags);
  }
  if (parsed.pill_format) config.pillFormat = parsed.pill_format;
  if (parsed.supply_pill_format) config.supplyPillFormat = parsed.supply_pill_format;
  return config;
}

// Highest row the bag count reaches; null when the table is empty or starts higher.
function skioResolveTierPercent(rows, bags, key) {
  let value = null;
  rows.forEach((row) => {
    if (bags >= row.bags) value = row[key || 'percent'];
  });
  return value;
}

function skioFormatPill(format, percent) {
  const rounded = Math.round(percent * 100) / 100;
  return String(format).replace(/\{percent\}/g, rounded);
}

function skioGetAddBtnLabel(tier) {
  if (!tier) return 'Select Flavors';
  return skioGetBagCountFromLabel(tier.label) <= 1 ? 'Select Flavor' : 'Select Flavors';
}

function skioUpdateShippingBenefit(root, tier) {
  const infoScope =
    root.closest('.product__info-container') ||
    root.closest('.featured-product') ||
    root.closest('.section-main-product-subs') ||
    root.parentElement ||
    document;
  const showShippingBenefit = skioGetBagCountFromLabel(tier?.label) === 3;

  infoScope.querySelectorAll('[data-skio-shipping-benefit]').forEach((benefit) => {
    benefit.classList.toggle('is-visible', showShippingBenefit);
  });
}

function initSkioWidget(root) {
  const raw = root.getAttribute('data-widget-json');
  if (!raw) return;

  let parsed;
  try {
    parsed = JSON.parse(raw);
  } catch (e) {
    console.error('Skio widget: invalid data-widget-json', e);
    return;
  }

  const { product, selling_plan_groups, selected_variant_id } = parsed;

  // Read tiers from Theme Settings (passed via data-tiers-json)
  let tiers = [];
  try {
    tiers = JSON.parse(root.getAttribute('data-tiers-json') || '[]');
  } catch (e) {
    console.error('Skio widget: invalid data-tiers-json', e);
  }

  // Fill the gaps the block left blank from the global table, keyed on the bag
  // count in the tier label ("3 BAGS" → 3). Anything the block did set wins.
  const discountConfig = skioParseDiscountTiers(root.getAttribute('data-discount-tiers'));
  tiers.forEach((tier) => {
    if (tier.discount_percent === null || tier.discount_percent === undefined) {
      const resolved = skioResolveTierPercent(discountConfig.rows, skioGetBagCountFromLabel(tier.label));
      tier.discount_percent = resolved === null ? 0 : resolved;
    }
    if (tier.total_discount === null || tier.total_discount === undefined) {
      tier.total_discount = tier.discount_percent > 0
        ? skioFormatPill(discountConfig.pillFormat, tier.discount_percent)
        : '';
    }
  });

  const plansToShow = parseInt(root.dataset.plansToShow, 10);
  if (!isNaN(plansToShow) && plansToShow > 0) tiers = tiers.slice(0, plansToShow);

  let defaultTierIdx = parseInt(root.dataset.defaultPlan, 10);
  if (isNaN(defaultTierIdx) || defaultTierIdx < 0 || defaultTierIdx >= tiers.length) defaultTierIdx = 0;

  const mostPopularIdx   = parseInt(root.dataset.mostPopularPlan, 10);
  const mostPopularColor = root.dataset.mostPopularColor || '#f05e2d';
  const mostPopularText  = root.dataset.mostPopularText  || 'Most Popular';
  const bestDealIdx      = parseInt(root.dataset.bestDealPlan, 10);
  const bestDealColor    = root.dataset.bestDealColor    || '#c0392b';
  const bestDealText     = root.dataset.bestDealText     || 'Best Deal';
  const planImages = [
    root.getAttribute('data-plan-image-1') || null,
    root.getAttribute('data-plan-image-2') || null,
    root.getAttribute('data-plan-image-3') || null,
    root.getAttribute('data-plan-image-4') || null,
  ];

  const optionsContainer = root.querySelector('.skio-widget__options');
  const addBtn           = root.querySelector('.skio-widget__add-btn');
  const messageEl        = root.querySelector('.skio-widget__message');
  const savingsEl        = root.querySelector('.skio-savings-amount');
  const btnOriginalEl    = root.querySelector('.skio-btn-original-price');
  const btnDiscountEl    = root.querySelector('.skio-btn-discounted-price');
  const footerSubtitleEl = root.querySelector('.skio-widget__footer-subtitle');

  if (!product || !product.variants || !product.variants.length) return;

  let selectedVariant = selected_variant_id
    ? product.variants.find(v => v.id === selected_variant_id)
    : null;
  if (!selectedVariant) {
    selectedVariant = product.variants.find(v => v.available) || product.variants[0];
  }

  let selectedTier = tiers.length ? tiers[defaultTierIdx] : null;
  skioUpdateShippingBenefit(root, selectedTier);

  // Collect Skio selling plans for frequency selector
  const sellingPlanGroup = selling_plan_groups && selling_plan_groups.length
    ? selling_plan_groups[0]
    : null;
  const allSellingPlans = sellingPlanGroup ? (sellingPlanGroup.selling_plans || []) : [];

  // Global plan IDs from Theme Settings; plans from every group, for name lookups
  const planSettings = skioParsePlanSettings(root.getAttribute('data-skio-plans'));
  const allGroupPlans = (selling_plan_groups || []).reduce(
    (acc, group) => acc.concat(group.selling_plans || []),
    []
  );

  skioUpdateButtonVisibility(root, selectedVariant.available);

  if (addBtn) {
    const btnText = addBtn.querySelector('span');
    if (selectedVariant.available) {
      addBtn.disabled = false;
      if (btnText) btnText.textContent = skioGetAddBtnLabel(selectedTier);
    } else {
      addBtn.disabled = true;
      if (btnText) btnText.textContent = 'Sold out';
    }
  }

  if (typeof subscribe !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
      if (!event.data || !event.data.variant) return;
      const variant = event.data.variant;
      if (!variant.id) return;
      skioUpdateButtonVisibility(root, variant.available);
      if (addBtn) {
        const btnText = addBtn.querySelector('span');
        if (variant.available) {
          addBtn.disabled = false;
          if (btnText) btnText.textContent = 'Select Flavors';
        } else {
          addBtn.disabled = true;
          if (btnText) btnText.textContent = 'Sold out';
        }
      }
      if (messageEl) messageEl.textContent = '';
    });
  }

  function updateSavings(tier) {
    if (!tier) return;
    const bagCount        = skioGetBagCountFromLabel(tier.label);
    const originalPrice   = selectedVariant.price / 100;
    const discountedPrice = originalPrice * (1 - (tier.discount_percent || 0) / 100);
    const savings         = (originalPrice - discountedPrice) * bagCount;
    const totalServings   = bagCount * 10;
    const pricePerServing = (discountedPrice * bagCount) / totalServings;
    const hasDiscount     = (tier.discount_percent || 0) > 0;

    const savingsBadge = savingsEl ? savingsEl.closest('.skio-savings-badge') : null;
    if (savingsBadge)       savingsBadge.style.display    = hasDiscount ? '' : 'none';
    if (savingsEl)          savingsEl.textContent         = hasDiscount ? `$${savings.toFixed(2)} SAVED` : '';
    if (btnOriginalEl)      btnOriginalEl.textContent     = hasDiscount ? `$${(originalPrice * bagCount).toFixed(2)}` : '';
    if (btnDiscountEl)      btnDiscountEl.textContent     = `$${(discountedPrice * bagCount).toFixed(2)}`;
    if (footerSubtitleEl)   footerSubtitleEl.textContent  = `${totalServings} Servings / $${pricePerServing.toFixed(2)} per serving`;
  }

  // Build tier selection cards from Theme Settings data
  if (optionsContainer && tiers.length) {
    tiers.forEach((tier, index) => {
      let badgeLabel = null;
      let badgeColor = '#f05e2d';
      if (!isNaN(mostPopularIdx) && index === mostPopularIdx) {
        badgeLabel = mostPopularText;
        badgeColor = mostPopularColor;
      } else if (!isNaN(bestDealIdx) && index === bestDealIdx) {
        badgeLabel = bestDealText;
        badgeColor = bestDealColor;
      }
      const card = skioCreateTierCard(tier, index, selectedVariant, index === defaultTierIdx, badgeLabel, badgeColor, planImages[index] || null);
      optionsContainer.appendChild(card);
    });

    updateSavings(selectedTier);

    optionsContainer.querySelectorAll('input[type="radio"][name="skio_tier"]').forEach(radio => {
      radio.addEventListener('change', (e) => {
        if (!e.target.checked) return;
        selectedTier = tiers[parseInt(e.target.value, 10)];
        optionsContainer.querySelectorAll('.skio-option').forEach(c => c.classList.remove('selected'));
        e.target.closest('.skio-option')?.classList.add('selected');
        updateSavings(selectedTier);
        skioUpdateShippingBenefit(root, selectedTier);
        const btnText = addBtn?.querySelector('span');
        if (btnText && !addBtn.disabled) btnText.textContent = skioGetAddBtnLabel(selectedTier);
      });
    });
  }

  // Move modal to <body> so fixed positioning isn't trapped by stacking contexts
  const modal = root.querySelector('#skio-flavor-modal');
  if (modal) {
    document.body.appendChild(modal);
    skioSetupModal(modal, product, allSellingPlans, planSettings, allGroupPlans, discountConfig);
  }

  const labelModal = root.querySelector('#skio-label-modal');
  if (labelModal) {
    document.body.appendChild(labelModal);
    skioSetupLabelModal(labelModal, modal);
  }

  const modalStatusText = root.dataset.modalStatusText || 'Select at least 1 bag';

  /* Flavors the modal seeds on open, read from the block settings. Off unless
   * the template opts in, so the widgets that already ship a 0/0/0 modal keep it. */
  const prefillConfig = {
    enabled: root.dataset.prefillFlavors === 'true',
    names: (root.dataset.prefillFlavorNames || '')
      .split(',')
      .map(name => name.trim().toLowerCase())
      .filter(Boolean),
  };

  if (addBtn) {
    addBtn.addEventListener('click', () => {
      if (addBtn.disabled || !selectedTier) return;
      skioOpenFlavorModal(modal, product, selectedTier, modalStatusText, prefillConfig);
    });
  }

  /* "Try it once" (one_time_cta block) opens the same modal in one-time mode
   * instead of following its link. The link stays as the no-JS / sold-out fallback. */
  const otpScope =
    root.closest('.section-main-product-subs') ||
    root.closest('.product__info-container') ||
    root.parentElement;
  if (otpScope && modal) {
    otpScope.querySelectorAll('[data-skio-otp-trigger]').forEach((trigger) => {
      trigger.addEventListener('click', (e) => {
        if (!addBtn || addBtn.disabled || !selectedTier) return;
        e.preventDefault();
        skioOpenFlavorModal(modal, product, selectedTier, modalStatusText, prefillConfig, 'otp');
      });
    });
  }
}

/* The modal prices the LIVE bag total, not the selected tier, so it needs the
 * same table the tier cards use. This used to be a hardcoded 9/6/3/2 ladder,
 * which meant a merchant could retune the cards and the modal footer would
 * keep quoting the old percentages. */
function skioDiscountForBagCount(rows, count) {
  const resolved = skioResolveTierPercent(rows || [], count);
  return resolved === null ? 0 : resolved;
}

// ── Modal: wire up all events once via delegation ──────────────────────
function skioSetupModal(modal, product, sellingPlans, planSettings, allGroupPlans, discountConfig) {
  const discountRows = (discountConfig && discountConfig.rows) || [];
  const state = {
    quantities: {},
    bagCount: 0,
    sellingPlanId: null,
    frequency: '30',
    tier: null,
    basePrice: 0,
    statusText: '',
    // 'sub' = opened from Select Flavors (frequency selector)
    // 'otp' = opened from "Try it once" (subscribe switch, starts off)
    mode: 'sub',
    subscribed: true,
  };

  const freqWrap  = modal.querySelector('.skio-modal__frequency-selector');
  const subToggle = modal.querySelector('.skio-modal__sub-toggle');

  function renderSubToggle(total) {
    if (freqWrap)  freqWrap.hidden  = state.mode === 'otp';
    if (!subToggle) return;
    subToggle.hidden = state.mode !== 'otp';
    const on  = state.subscribed;
    const pct = skioDiscountForBagCount(discountRows, Math.max(total, 1));
    subToggle.setAttribute('aria-checked', on ? 'true' : 'false');
    subToggle.classList.toggle('is-on', on);
    const labelEl = subToggle.querySelector('.skio-modal__sub-label');
    const noteEl  = subToggle.querySelector('.skio-modal__sub-note');
    if (labelEl) {
      const base = on ? 'Subscribed · Saving' : 'Subscribe & Save';
      labelEl.textContent = pct > 0 ? `${base} ${pct}%` : (on ? 'Subscribed' : 'Subscribe & Save');
    }
    if (noteEl) noteEl.textContent = `Ships every ${state.frequency} days · cancel anytime`;
  }

  modal._skioState   = state;
  modal._skioProduct = product;

  function closeModal() {
    modal.setAttribute('hidden', '');
    modal.setAttribute('aria-hidden', 'true');
  }

  function getTotal() {
    return Object.values(state.quantities).reduce((s, q) => s + q, 0);
  }

  function updateUI() {
    const total = getTotal();

    modal.querySelectorAll('.skio-stepper__value').forEach(el => {
      const vid = parseInt(el.dataset.vid, 10);
      el.textContent = state.quantities[vid] ?? 0;
    });
    modal.querySelectorAll('.skio-stepper__minus').forEach(btn => {
      btn.disabled = (state.quantities[parseInt(btn.dataset.vid, 10)] || 0) === 0;
    });
    modal.querySelectorAll('.skio-stepper__plus').forEach(btn => {
      btn.disabled = false; // sin límite superior
    });

    const checkoutBtn = modal.querySelector('.skio-modal__checkout-btn');
    if (checkoutBtn) checkoutBtn.disabled = total < 1;

    // Texto estático desde settings
    const statusEl = modal.querySelector('.skio-modal__status');
    if (statusEl) statusEl.textContent = state.statusText;

    renderSubToggle(total);

    // Precios dinámicos según total de bags (one-time = full price)
    const discountPercent  = state.subscribed ? skioDiscountForBagCount(discountRows, total) : 0;
    const originalTotal    = state.basePrice * total;
    const discountedTotal  = originalTotal * (1 - discountPercent / 100);
    const hasDiscount      = discountPercent > 0;
    // Free shipping follows the bag count alone, so a one-time order (0% off) still shows it
    const badgeParts = [];
    if (hasDiscount) badgeParts.push(`${discountPercent}% Off`);
    if (total >= 3)  badgeParts.push('Free Shipping');

    const badge  = modal.querySelector('.skio-modal__discount-badge');
    const origEl = modal.querySelector('.skio-modal__original-price');
    const discEl = modal.querySelector('.skio-modal__discounted-price');

    if (badge)  badge.textContent  = badgeParts.join(' + ');
    if (origEl) origEl.textContent = total > 0 && hasDiscount ? `$${originalTotal.toFixed(2)}` : '';
    if (discEl) discEl.textContent = total > 0 ? `$${discountedTotal.toFixed(2)}` : '';
  }

  // Build frequency selector — from Theme Settings plan IDs when configured,
  // otherwise fall back to the product's own Skio selling plans
  const freqContainer = modal.querySelector('.skio-modal__frequency-selector');
  if (freqContainer && planSettings) {
    const frequencies = SKIO_PLAN_FREQUENCIES.filter(
      (freq) => planSettings.single[freq] || planSettings.multi[freq]
    );
    state.frequency = frequencies[0] || '30';

    const select = document.createElement('select');
    select.className = 'skio-freq__select';
    select.setAttribute('aria-label', 'Delivery frequency');

    frequencies.forEach((freq, i) => {
      const option = document.createElement('option');
      option.value = freq;
      const planId    = planSettings.multi[freq] || planSettings.single[freq];
      const namedPlan = (allGroupPlans || []).find((p) => p.id === planId);
      option.textContent = namedPlan ? namedPlan.name : `Every ${freq} days`;
      option.selected = i === 0;
      select.appendChild(option);
    });

    select.addEventListener('change', (e) => {
      state.frequency = e.target.value;
    });

    freqContainer.appendChild(select);
  } else if (freqContainer && sellingPlans.length) {
    const defaultIdx    = 0; // default: first plan (Every 30 days)
    state.sellingPlanId = sellingPlans[defaultIdx].id;

    const select = document.createElement('select');
    select.className = 'skio-freq__select';
    select.setAttribute('aria-label', 'Delivery frequency');

    sellingPlans.forEach((plan, i) => {
      const option = document.createElement('option');
      option.value    = plan.id;
      option.textContent = plan.name;
      option.selected = i === defaultIdx;
      select.appendChild(option);
    });

    select.addEventListener('change', (e) => {
      state.sellingPlanId = parseInt(e.target.value, 10);
    });

    freqContainer.appendChild(select);
  }

  // Delegated event handling for close, steppers, and checkout
  modal.addEventListener('click', (e) => {
    if (e.target === modal || e.target.closest('.skio-modal__close')) {
      closeModal();
      return;
    }

    if (e.target.closest('.skio-modal__sub-toggle')) {
      state.subscribed = !state.subscribed;
      updateUI();
      return;
    }

    const plusBtn  = e.target.closest('.skio-stepper__plus');
    const minusBtn = e.target.closest('.skio-stepper__minus');

    if (plusBtn) {
      const vid = parseInt(plusBtn.dataset.vid, 10);
      state.quantities[vid] = (state.quantities[vid] || 0) + 1;
      updateUI();
    }
    if (minusBtn) {
      const vid = parseInt(minusBtn.dataset.vid, 10);
      if ((state.quantities[vid] || 0) > 0) {
        state.quantities[vid]--;
        updateUI();
      }
    }

    const checkoutBtn = modal.querySelector('.skio-modal__checkout-btn');
    if (e.target.closest('.skio-modal__checkout-btn') && checkoutBtn && !checkoutBtn.disabled) {
      // Plan set follows the live total: 1 bag → single plan, 2+ → 2+ plan
      const legacyPlanId  = state.sellingPlanId || (sellingPlans[0] && sellingPlans[0].id) || null;
      const sellingPlanId = state.subscribed
        ? skioResolvePlanId(planSettings, getTotal(), state.frequency, legacyPlanId)
        : null;

      // One-time lines go in without a selling_plan key
      const items = Object.entries(state.quantities)
        .filter(([, qty]) => qty > 0)
        .map(([vid, qty]) => {
          const item = { id: parseInt(vid, 10), quantity: qty };
          if (sellingPlanId) item.selling_plan = sellingPlanId;
          return item;
        });

      if (!items.length) return;

      const checkoutLabel = modal.querySelector('.skio-modal__checkout-label');
      checkoutBtn.disabled = true;
      if (checkoutLabel) checkoutLabel.textContent = 'Adding...';

      fetch(routes.cart_add_url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items }),
      })
        .then(r => r.json())
        .then(response => {
          if (response.status) {
            if (checkoutLabel) checkoutLabel.textContent = 'Error — Try again';
            checkoutBtn.disabled = false;
            return;
          }
          closeModal();
          window.location = '/checkout';
        })
        .catch(() => {
          if (checkoutLabel) checkoutLabel.textContent = 'Error — Try again';
          checkoutBtn.disabled = false;
        });
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hasAttribute('hidden')) closeModal();
  });

  modal._skioUpdateUI = updateUI;
  modal._skioState    = state;
}

/* ── Pre-fill the flavor modal with the selected tier's bags ──────────────
 * Opt-in per block ("Pre-fill flavors when the modal opens").
 *
 * 3 bags and up spread evenly across every flavor the modal renders a stepper
 * for, exactly like the V2 widget: 3 → 1/1/1, 6 → 2/2/2, with any remainder
 * landing on the first flavors (4 → 2/1/1).
 *
 * Below that there aren't enough bags to reach every flavor, and these widgets
 * can offer a 2-bag tier, so an even spread would pick two flavors by position
 * alone. Those tiers go to the flavors the merchant named instead — Orange and
 * Lemon by default: 1 bag → Orange, 2 bags → Orange + Lemon.
 *
 * Nothing is capped either way — the shopper can restep every flavor after.
 */
var SKIO_PREFILL_EVEN_SPREAD_MIN_BAGS = 3;

function skioBuildPrefillQuantities(modal, product, bags, names) {
  /* Read the steppers instead of product.variants: Liquid skips sold-out
   * variants and those flagged custom.out_of_stock, so this can never pre-fill
   * a bag the shopper has no control to remove. */
  const vids = Array.from(modal.querySelectorAll('.skio-stepper__value'))
    .map(el => parseInt(el.dataset.vid, 10))
    .filter(id => !isNaN(id));
  if (!vids.length || !bags || bags < 1) return null;

  const titleOf = (id) => {
    const variant = product.variants.find(v => v.id === id);
    return (variant && variant.title ? variant.title : '').toLowerCase();
  };

  // Every available flavor by default; the small tiers narrow this below.
  let pool = vids;

  if (bags < SKIO_PREFILL_EVEN_SPREAD_MIN_BAGS) {
    const targets = [];
    (names || []).forEach((name) => {
      vids.forEach((id) => {
        if (titleOf(id).includes(name) && targets.indexOf(id) === -1) targets.push(id);
      });
    });
    // Keep the even spread when none of the named flavors are in stock
    if (targets.length) pool = targets;
  }

  const quantities = {};
  vids.forEach(id => { quantities[id] = 0; });
  const perFlavor = Math.floor(bags / pool.length);
  const leftover  = bags % pool.length;
  pool.forEach((id, i) => { quantities[id] = perFlavor + (i < leftover ? 1 : 0); });
  return quantities;
}

// ── Open modal: reset state + show ────────────────────────────────────
function skioOpenFlavorModal(modal, product, tier, statusText, prefill, mode) {
  if (!modal) return;

  const state        = modal._skioState;
  state.tier         = tier;
  state.statusText   = statusText || 'Select at least 1 bag';
  state.mode         = mode === 'otp' ? 'otp' : 'sub';
  state.subscribed   = state.mode === 'sub';

  const baseVariant  = product.variants.find(v => v.available) || product.variants[0];
  state.basePrice    = baseVariant.price / 100;

  // Reset quantities
  state.quantities = {};
  product.variants.filter(v => v.available).forEach(v => { state.quantities[v.id] = 0; });

  // The one-time flow always seeds the bag count picked in the buy box (DS)
  if (prefill && (prefill.enabled || state.mode === 'otp')) {
    const seeded = skioBuildPrefillQuantities(
      modal, product, skioGetBagCountFromLabel(tier && tier.label), prefill.names
    );
    if (seeded) Object.assign(state.quantities, seeded);
  }

  const checkoutLabel = modal.querySelector('.skio-modal__checkout-label');
  if (checkoutLabel) checkoutLabel.textContent = 'CHECKOUT';

  modal._skioUpdateUI();
  modal.removeAttribute('hidden');
  modal.setAttribute('aria-hidden', 'false');
}

// ── Create a tier selection card ───────────────────────────────────────
function skioCreateTierCard(tier, tierIndex, variant, isFirst, badgeLabel, badgeColor, imageUrl) {
  const originalPrice   = variant.price / 100;
  const discountPercent = tier.discount_percent || 0;
  const discountedPrice = originalPrice * (1 - discountPercent / 100);

  const label = document.createElement('label');
  label.className = 'skio-option' + (isFirst ? ' selected' : '');

  if (badgeLabel) {
    const badge = document.createElement('div');
    badge.className = 'skio-option__badge';
    badge.style.backgroundColor = badgeColor;
    badge.textContent = badgeLabel;
    label.appendChild(badge);
  }

  const radio = document.createElement('input');
  radio.type      = 'radio';
  radio.className = 'skio-option__radio';
  radio.name      = 'skio_tier';
  radio.value     = tierIndex;
  radio.checked   = isFirst;

  const content = document.createElement('div');
  content.className = 'skio-option__content';

  const left = document.createElement('div');
  left.className = 'skio-option__left';
  left.innerHTML = `
    <div class="skio-option__title">${tier.label}</div>
    <div class="skio-option__price">$${discountedPrice.toFixed(2)}${skioGetBagCountFromLabel(tier.label) > 1 ? '/ea' : ''}</div>
    ${tier.total_discount ? `<div class="skio-option__percentage">${tier.total_discount}</div>` : ''}
  `;
  content.appendChild(left);

  if (imageUrl) {
    const imgWrapper = document.createElement('div');
    imgWrapper.className = 'skio-option__image';
    const img = document.createElement('img');
    img.src     = imageUrl;
    img.alt     = tier.label;
    img.loading = 'lazy';
    imgWrapper.appendChild(img);
    content.appendChild(imgWrapper);
  }

  label.appendChild(radio);
  label.appendChild(content);
  return label;
}

// ── Label image dialog ────────────────────────────────────────────────
function skioSetupLabelModal(labelModal, flavorModal) {
  const img = labelModal.querySelector('.skio-label-modal__image');

  function openLabel(src, alt) {
    if (!src) return;
    img.src = src;
    img.alt = alt || '';
    labelModal.removeAttribute('hidden');
    labelModal.setAttribute('aria-hidden', 'false');
  }

  function closeLabel() {
    labelModal.setAttribute('hidden', '');
    labelModal.setAttribute('aria-hidden', 'true');
    img.src = '';
  }

  // Delegated click on the flavor modal: catch "View Label" buttons
  if (flavorModal) {
    flavorModal.addEventListener('click', (e) => {
      const trigger = e.target.closest('.skio-modal__card-label');
      if (!trigger) return;
      e.preventDefault();
      openLabel(trigger.dataset.labelImage, trigger.dataset.labelAlt);
    });
  }

  labelModal.addEventListener('click', (e) => {
    if (e.target === labelModal || e.target.closest('.skio-label-modal__close')) {
      closeLabel();
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !labelModal.hasAttribute('hidden')) closeLabel();
  });
}
